function setupSimpleSlider(sliderId) {
  const slider = document.getElementById(sliderId);
  if (!slider) return;

  const track = slider.querySelector('.slider-track');
  const slides = track.children;
  let index = 0;
  let startX = 0;
  let isDragging = false;
  let animationId;
  let autoplay;

  function slideTo(index) {
    const translateX = -index * 100;
    track.style.transition = 'transform 0.6s ease';
    track.style.transform = `translateX(${translateX}%)`;
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    slideTo(index);
  }

  function startAutoplay() {
    autoplay = setInterval(nextSlide, 4000);
  }

  function stopAutoplay() {
    clearInterval(autoplay);
  }

  // Touch/Mouse logic
  const getX = (e) => (e.touches ? e.touches[0].clientX : e.clientX);

  const onStart = (e) => {
    isDragging = true;
    startX = getX(e);
    stopAutoplay();
    track.style.transition = 'none';
  };

  const onMove = (e) => {
    if (!isDragging) return;
    const currentX = getX(e);
    const delta = currentX - startX;
    const percent = (delta / slider.offsetWidth) * 100;
    track.style.transform = `translateX(calc(-${index * 100}% + ${percent}%))`;
  };

  const onEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;
    const endX = getX(e);
    const moved = endX - startX;

    if (moved < -50 && index < slides.length - 1) {
      index++;
    } else if (moved > 50 && index > 0) {
      index--;
    }

    slideTo(index);
    startAutoplay();
  };

  track.addEventListener('mousedown', onStart);
  track.addEventListener('mousemove', onMove);
  track.addEventListener('mouseup', onEnd);
  track.addEventListener('mouseleave', () => isDragging && onEnd());

  track.addEventListener('touchstart', onStart);
  track.addEventListener('touchmove', onMove);
  track.addEventListener('touchend', onEnd);

  track.querySelectorAll('img').forEach(img => img.setAttribute('draggable', 'false'));

  slideTo(index);
  startAutoplay();
}

document.addEventListener("DOMContentLoaded", () => {
  setupSimpleSlider('slider1');
  setupSimpleSlider('slider2');
});
